<template>
  <app-header />
  <Suspense>
    <template #default>
      <app-home-page />
    </template>
    <template #fallback>
      <app-loading />
    </template>
  </Suspense>
  <app-footer />
</template>

<script>
// @ is an alias to /src
import AppHeader from '@/components/Include/AppHeader.vue'
import AppFooter from '@/components/Include/AppFooter.vue'
import { defineAsyncComponent } from 'vue';
import AppLoading from '@/components/Spinners/AppLoading.vue';
const AppHomePage = defineAsyncComponent(() =>
  import('@/components/Pages/AppHomePage')
)
export default {
  name: 'HomeView',
  components: {
    AppHeader,
    AppFooter,
    AppHomePage,
    AppLoading,
  }
}
</script>

<script setup>
import { useHead } from '@vueuse/head';
useHead({
  title: 'الرئيسية | Trends Today',
  meta: [
    { name: 'description', content: 'شاهد أحدث الفيديوهات والأحداث الحصرية على Trends Today من MTN السودان. محتوى ترفيهي، رياضي، وثقافي وأكثر.' },
    { name: 'keywords', content: 'فيديو, أحداث, MTN, ترند, السودان, ترفيه, رياضة, ثقافة' },
    { name: 'author', content: 'Trends MTN Team' },
    { name: 'robots', content: 'index, follow' },
    { property: 'og:type', content: 'website' },
    { property: 'og:title', content: 'Trends Today - الرئيسية' },
    { property: 'og:description', content: 'شاهد أحدث الفيديوهات والأحداث الحصرية على Trends Today من MTN السودان. محتوى ترفيهي، رياضي، وثقافي وأكثر.' },
    { property: 'og:image', content: 'https://trendtody.com/assets/img/trends.png' },
    { property: 'og:url', content: 'https://trendtody.com/' },
    { name: 'twitter:card', content: 'summary_large_image' },
    { name: 'twitter:title', content: 'Trends Today - الرئيسية' },
    { name: 'twitter:description', content: 'شاهد أحدث الفيديوهات والأحداث الحصرية على Trends Today من MTN السودان. محتوى ترفيهي، رياضي، وثقافي وأكثر.' },
    { name: 'twitter:image', content: 'https://trendtody.com/assets/img/trends.png' }
  ]
});
</script>
